<p-dialog
  position="middle"
  [id]="id"
  class="mu-modal {{ !showCloseIcon && 'mu-modal-hide-close' }}"
  [(visible)]="showModalState"
  (onHide)="_eventCloseDialogModal()"
  [ngClass]="{ 'mu-modal-big-content': bigContent, 'mu-modal-fullscreen-content' : fullscreeContent }"
>
  <div [class]="'p-grid p-justify-center p-align-center ' + classContentModal" [ngClass]="{ 'mu-fullHeight' : fullscreeContent }">
    <div class="p-col-12 mu-without-padding" *ngIf="icon">
      <i class="fas {{ icon }}" aria-hidden="true"></i>
    </div>
    <h1 class="p-col-12" [innerHTML]="title"></h1>
    <h3 class="p-col-12" *ngIf="subTitle || subTitleValue">
      <strong
        ><span *ngIf="subTitle">{{ subTitle }}:&nbsp;</span> <span *ngIf="subTitleValue">{{ subTitleValue }}</span></strong
      >
    </h3>
    <div *ngIf="!hideLine" class="mu-modal-line"></div>
    <ng-content select="[modalDialogContent]"></ng-content>
    <div class="p-col-12 mu-without-padding">
      <div class="p-grid mu-modal-buttons mu-mobile-column-reverse" [ngClass]="{ 'mu-modal-big-content': bigContent }">
        <ng-content select="[modalDialogButton]"></ng-content>

        <div
          class="p-col-12 p-md-{{ actionFlag ? '6' : '12' }} mu-modal-button mu-modal-button-left"
          *ngIf="buttonCancel || buttonCancelLink || buttonCancelLabel"
        >
          <p-button
            [label]="buttonCancelLabel || 'form.button.cancel' | translate"
            class="mu-button mu-button-outline {{ buttonSlim ? 'mu-button-slim' : '' }}"
            [ngClass]="{ 'mu-modal-big-content-button': bigContent }"
            (click)="_eventCancelAction()"
          ></p-button>
        </div>
        <div
          class="p-col-12 p-md-{{
            buttonCancel || buttonCancelLabel || buttonCancelLink ? '6' : '12'
          }} mu-modal-button mu-modal-button-right"
          *ngIf="actionFlag"
        >
          <p-button
            [disabled]="formData && formData.get('isInvalidForm')?.value"
            [label]="buttonMainActionLabel || 'form.button.save' | translate"
            class="mu-button  {{ buttonSlim ? 'mu-button-slim' : '' }}"
            (click)="_eventMainAction()"
          >
            <app-loading [showLoading]="flagList.get(loaderFlag)" type="icon"></app-loading>
          </p-button>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
